import { createContext } from 'react';

import { createMongoAbility } from '@casl/ability';
export const ability = createMongoAbility([]);
export const AbilityContext = createContext(ability);
